import React from 'react';
import { Button } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import DeclarationDiff, { declarationHeading } from '../DeclarationDiff';
import ChangeDetailBar from './ChangeDetailBar';

/**
 * Consumer detail panel: read-only. The log, when the reader shows it from the
 * bar (it explains what happened), then the declaration — a diff, a creation
 * or a deletion (declarationHeading) — across the full width of the entry.
 */
const ConsumerChangeDetail = ({ record, extraProps }: { record: Record<string, any>; extraProps?: any }) => {
    const heading = declarationHeading(record);
    return (
        <div className="ci-detail">
            <ChangeDetailBar record={record} resource={extraProps?.resource}>
                {record.submission?.id && (
                    <Link to={`/submissions/${record.submission.id}/`}>
                        <Button icon={<ExportOutlined />}>Submission page</Button>
                    </Link>
                )}
            </ChangeDetailBar>

            <section className="ci-block">
                <header className="ci-block__head">
                    <heading.Icon className="ci-block__icon" aria-hidden="true" />
                    <h4 className="ci-block__title">{heading.title}</h4>
                </header>
                <div className="ci-diff">
                    <DeclarationDiff change_instance={record} />
                </div>
            </section>
        </div>
    );
};

export default ConsumerChangeDetail;
